<template>
  <div>
      请先登录
  </div>
</template>

<script>
export default {
    name:'Error'
}
</script>

<style>

</style>